import React, { lazy } from 'react'
import Loadable from 'app/components/Loadable/Loadable';
// const Stockinward = Loadable(lazy(() => import("./Stockinward")));
const Stockinward = Loadable(lazy(() => import("./StockinwardNew")));
const Stockinwardadd = Loadable(lazy(() => import("./Stockinwardadd")));
const StockinwardView= Loadable(lazy(() => import("./StockinwardView")));
const StockinwardApproval= Loadable(lazy(()=> import("./StockinwardApproval")));
const StockinwardRoutes = [
    {
        path: '/stockinward',
        element: <Stockinward />,
    },
    {
        path: '/stockinward/add',
        element: <Stockinwardadd />,
    },
    {
        path: '/stockinward/edit/:stockid',
        element: <Stockinwardadd />,
    },
    {
        path: '/stockinward/view/:id',
        element: <StockinwardView />,
    },
    {
        path: '/stockinwardapproval/approval/:stockid',
        element: <StockinwardApproval/>,
    },
]

export default StockinwardRoutes
